import React from 'react';
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';

const HoverInfoIconTooltip = ({ children, position, iconName = 'icon-info', iconHeight = 14, iconColor = '',className,  tooltipClassName = '', iconWidth }) => {
    const getPositionClass = () => {
        switch (position) {
            case 'bottom-left':
                return 'block-tooltip-bottom-left';
            case 'top-center':
                return 'block-tooltip-top-center';
            case 'bottom-center':
                return 'block-tooltip-bottom-center';
            case 'bottom-right':
                return 'block-tooltip-bottom-right';
            default:
                return 'block-tooltip';
        }
    };


    return (
        <>
            <CIcon icon={iconName} className={`hover-show-tooltip ${className}`} height={iconHeight} style={{ color: iconColor }} width={iconWidth}></CIcon>
            <div className={`${getPositionClass()} custom-width ${tooltipClassName}`}>
                <CIcon icon="arrow-preview" className="arrow-preview"></CIcon>
                <div className="block-tooltip-text custom-tooltip-text">{children}</div>
            </div>
        </>
    );
}


HoverInfoIconTooltip.propTypes = {
     iconHeight: PropTypes.any,
     iconWidth: PropTypes.any,
     children: PropTypes.node,
     position: PropTypes.any,
     iconName: PropTypes.string,
     iconColor: PropTypes.any,
     tooltipClassName: PropTypes.string,
};

export default HoverInfoIconTooltip
